<template>
  <div class="text-center">
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown || step === 'send'"
      max-width="1000"
      v-model="dialog"
      scrollable
      :persistent="creating"
    >
      <v-card>
        <v-card-title class="primary white--text text-uppercase">
          Thêm Học sinh theo tệp Excel <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon :disabled="creating" @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            class="d-flex flex-column justify-center align-center mx-auto"
            style="width: 330px; min-height: 320px"
            v-if="step === 'import'"
          >
            <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
            <div class="text-center content-text mt-5" @click="exportExcelTemplate">
              Tải lên tệp excel (.xlsx) để thêm mới Học sinh theo danh sách sẵn có
            </div>
            <div class="mt-5">
              <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
              <v-btn color="primary" class="elevation-0" :loading="isSelecting" @click="onExcelUpload">
                <span>Chọn tệp</span>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-btn>
            </div>
          </div>
          <div class="pa-5" style="height: 100%" v-else-if="step === 'send'">
            <div v-if="creating">
              <div class="mb-2">
                <v-progress-circular indeterminate color="primary" class="mr-4"></v-progress-circular>
                <span> Đang tạo học sinh... </span>
              </div>
              <v-progress-linear v-model="progress" color="success" height="25" rounded>
                <strong>{{ Math.ceil(progress) }}%</strong>
              </v-progress-linear>
            </div>
            <div class="d-flex align-center" v-else>
              <v-text-field
                v-model="selectedFile.name"
                outlined
                prepend-inner-icon="mdi-file"
                disabled
                hide-details
              ></v-text-field>
              <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
            </div>

            <div v-if="excelErrorStudents.length">
              <div class="text-h6 mt-4 error--text">Lỗi dữ liệu</div>
              <div>
                Đã có {{ excelErrorStudents.length }} học sinh trong tệp excel gặp lỗi. Vui lòng kiểm tra lại dữ liệu và
                ấn
                <span>
                  <b> [Chọn tệp khác] </b>
                </span>
                để upload file excel mới.
              </div>
              <v-card outlined class="mt-4">
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  :headers="errorHeaders"
                  :items="excelErrorStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả',
                  }"
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:[`item.index`]="{ item }">
                    {{ excelErrorStudents.indexOf(item) + 1 }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
            <div v-else>
              <div class="my-4">
                <span class="error--text">*</span
                ><b>Vui lòng kiểm tra lại thông tin học sinh và ấn [Thêm học sinh] để tạo mới danh sách HS</b><br />
              </div>
              <v-card outlined>
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  item-key="studentCode"
                  :headers="originHeaders"
                  :items="excelStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả',
                  }"
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên
                    {{ items.itemsLength }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </div>
          <div class="pa-5" style="height: 100%" v-else-if="step === 'result'">
            <div v-if="errorCreatedStudents.length">
              <div class="text-h6 mt-4 error--text">Lỗi tạo mới HS</div>
              <div>
                Đã có {{ errorCreatedStudents.length }} học sinh gặp lỗi khi tạo mới.
                <span>
                  <b> Vui lòng upload lại file excel với chỉ những HS tạo lỗi. </b>
                </span>
              </div>
              <v-card outlined class="mt-4">
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  :headers="errorCreatedHeaders"
                  :items="errorCreatedStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả',
                  }"
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:[`item.index`]="{ item }">
                    {{ errorCreatedStudents.indexOf(item) + 1 }}
                  </template>
                  <template v-slot:[`item.dob`]="{ item }">
                    {{ item.dob | ddmmyyyy }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
            <div v-else>
              Tạo mới thành công {{ excelStudents.length }} học sinh. Vui lòng xem thông tin học sinh tại màn hình Danh
              sách học sinh
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="step === 'send'">
          <div class="d-flex justify-space-between align-center" style="width: 100%" v-if="excelStudents.length > 0">
            <v-btn color="gray" class="ma-2 px-8" :disabled="creating" @click="cancel" outlined>Hủy</v-btn>
            <v-btn color="primary" class="elevation-0 px-8" :loading="creating" @click="addStudents"
              >Thêm học sinh</v-btn
            >
          </div>
          <div class="d-flex justify-space-between align-center" style="width: 100%" v-else>
            <v-btn color="gray" class="ma-2 px-8" @click="cancel" outlined>Hủy</v-btn>
          </div>
        </v-card-actions>
        <v-card-actions v-else-if="step === 'result'">
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="elevation-0 px-8" @click="cancel">OK</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { max, chunk, get, keyBy, flatten } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
import moment from 'moment'

import { Student, Class, UserMeta } from '@/plugins/api'
import { textHelpers } from '@/helpers/TextHelper.js'
import utils from '@/plugins/utils'
import { schema } from './AddStudentByExcelDialog/schema'
import { originHeaders } from './AddStudentByExcelDialog/originHeaders'
import { errorHeaders } from './AddStudentByExcelDialog/errorHeaders'
import { errorCreatedHeaders } from './AddStudentByExcelDialog/errorCreatedHeaders'

export default {
  components: {},
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      creating: false,
      progress: 0,
      isSelecting: false,
      selectedFile: null,
      excelStudents: [],
      excelErrorStudents: [],
      errorCreatedStudents: [],
      step: 'import',
      classes: {},
      originHeaders: originHeaders,
      errorHeaders: errorHeaders,
      errorCreatedHeaders: errorCreatedHeaders,
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
  },
  methods: {
    ...mapActions('auth', ['user']),

    async addStudents() {
      this.errorCreatedStudents = []

      // mapping data
      const students = this.excelStudents.map(student => {
        const name = textHelpers.removeSpaces(student.studentName)
        let userNameIndex = utils.generateUserName(utils.clearUnicode(name))
        userNameIndex = utils.removeUnicode(userNameIndex).toLowerCase()
        const code = student.code
        const currentClass = this.classes[`${student.studentClass}`]

        const s = {
          ...student,
          name,
          code,
          index: +student.studentCode,
          formatedName: utils.generateNameToSort(name),
          tags: utils.generateUserTags(name, code),
          nameToNumber: utils.generateNameToNumber(utils.generateNameToSort(name)),
          status: 'active',
          gender: student.gender && student.gender.toLowerCase() === 'nữ' ? 'female' : 'male',
          dob: moment(student.dob, 'DD/MM/YYYY').toISOString(),
          currentClass: currentClass.id,
          classes: [currentClass.id],
          grade: get(currentClass, 'grade.id'),
          data: {
            ...student,
            username_indexing: userNameIndex,
            username: +student.studentCode + userNameIndex,
            username_no: +student.studentCode,
          },
        }
        return s
      })

      // save students
      this.creating = true
      const groups = chunk(students, 5)
      let count = 1
      const length = groups.length
      let createdError = false
      for (const subStudents of groups) {
        try {
          if (!createdError) {
            const maxIndexInGroup = max(subStudents.map(s => s.index))
            await Promise.all(subStudents.map(student => Student.create(student)))
            await UserMeta.updateIndexUser({ indexUser: maxIndexInGroup })
          } else break
          this.progress = (count / length) * 100
          count++
        } catch (error) {
          // lỗi -> xóa những hs trong nhóm vừa tạo
          const errorGroup = groups[count - 1]
          const errorStudents = flatten(
            await Promise.all(
              errorGroup.map(student =>
                Student.fetch({
                  code: student.code,
                  _limit: 1,
                })
              )
            )
          )
          await Promise.all(
            errorStudents.map(s => {
              if (s.id) return Student.remove(s.id)
            })
          )

          createdError = true
          console.error(error)
        }
      }

      if (createdError) {
        let createdStudentInErrorGroups = flatten(groups.slice(count - 1))
        this.errorCreatedStudents = createdStudentInErrorGroups
      }
      this.creating = false
      this.step = 'result'
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.excelErrorStudents = []
      this.excelStudents = []
      this.selectedFile = null
      this.step = 'import'
    },
    cancelChooseFile() {
      this.step = 'import'
      this.selectedFile = null
      this.excelStudents = []
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      console.log(e)

      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
        })
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        const isValid = await this.validateExcelData(results)
        if (isValid) {
          // student index
          const userMeta = await UserMeta.fetch()
          const indexFrom = get(userMeta, 'indexUser', 0) + 1
          const students = results.map((student, index) => {
            return { studentCode: indexFrom + index, ...student }
          })

          this.excelStudents = students
        }

        this.step = 'send'
      }

      this.$loading.active = false
    },
    async validateExcelData(students) {
      // fetch classes
      const allClasses = await Class.fetch({ _limit: -1 })
      this.classes = keyBy(allClasses, 'title')

      const excelErrorStudents = []
      for (const student of students) {
        let errorMsg = ''
        const studentName = student.studentName && textHelpers.removeSpaces(student.studentName)
        const isValidClass = student.studentClass && this.classes[`${student.studentClass.trim()}`]
        const isValidDob = student.dob && moment(student.dob.trim(), 'DD/MM/YYYY', true).isValid()

        if (student.code) {
          const count = await Student.count({ code: student.code })
          if (count > 0) errorMsg += (errorMsg ? ', ' : '') + 'Mã học sinh đã tồn tại'
        }
        if (!student.code) errorMsg = 'Thiếu mã học sinh'
        if (!studentName) errorMsg = 'Tên không hợp lệ'
        if (!isValidClass) errorMsg += (errorMsg ? ', ' : '') + 'Lớp không tồn tại'
        if (!isValidDob) errorMsg += (errorMsg ? ', ' : '') + 'Ngày sinh không hợp lệ'

        if (textHelpers.removeSpaces(student.email)) {
          const isValidEmail =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              student.email.trim()
            )
          if (!isValidEmail) errorMsg += (errorMsg ? ', ' : '') + 'Email không hợp lệ'
        }

        if (errorMsg) {
          excelErrorStudents.push({
            ...student,
            errorMsg,
          })
        }
      }

      this.excelErrorStudents = excelErrorStudents
      if (excelErrorStudents.length) return false
      return true
    },
    async exportExcelTemplate() {
      this.$loading.active = true
      console.log('run to export')
      window.location.href = `${this.$baseUrl}DanhSachHS.xlsx`
      this.$loading.active = false
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>

<style scoped>
.send-sms-container td:nth-child(1) {
  font-weight: bold;
  text-align: end;
  vertical-align: top;
}
.send-sms-container td:nth-child(2) {
  padding-left: 50px;
}
tr.spaceUnder > td {
  padding-bottom: 30px;
}
</style>
